import axios from "axios";
import PartyCircles from "@/components/party-circles";
import LocationChooser from "@/components/location-chooser";
import DateToFormat from "@/components/date-to-format";
import NAVIGATION from "@/data/navigation.yml";
import MEDIA from "@/data/media.yml";
import dynamicLocalization from "@/mixins/dynamic-localization";
import objToDate from "@/mixins/obj-to-date";

const TICKET_SALE_START = JSON.parse(process.env.VUE_APP_TICKET_SALE_START);
const PARTY_DATE = JSON.parse(process.env.VUE_APP_PARTY_DATE);

export default {
  components: { PartyCircles, LocationChooser, DateToFormat },
  mixins: [dynamicLocalization, objToDate],
  data() {
    const ticketSaleStartDate = this.objToDate(TICKET_SALE_START);

    const partyDate = new Date(
      Date.UTC(PARTY_DATE.year, PARTY_DATE.month - 1, PARTY_DATE.day)
    );

    const ticketSaleStartDateKnown =
      process.env.VUE_APP_TICKET_SALE_START !=
      process.env.VUE_APP_NEXT_PARTY_DATE;

    const now = new Date();

    return {
      build: {
        stage: process.env.VUE_APP_STAGE,
        date: new Date(parseInt(process.env.VUE_APP_BUILD_TIME) * 1000),
        version: process.env.VUE_APP_BUILD_VERSION,
      },
      ticketSaleStart: ticketSaleStartDateKnown ? ticketSaleStartDate : now,
      partyDate: partyDate,
      now: now,
      navOpen: false,
      twitterActive: false,
      authURL: process.env.VUE_APP_AUTH_URL,
      user: null,
      showTicketNote: true,
      ticketsAvailable: process.env.VUE_APP_TICKETS_AVAILABLE === "true",
      ticketSaleStartDateKnown,
      locationChooserActive: this.$route.name == "root",
      languages: [
        {
          locale: "en",
          name: "English",
        },
        {
          locale: "de",
          name: "Deutsch",
        },
        {
          locale: "it",
          name: "Italiano",
        },
      ],
      MEDIA,
    };
  },
  created() {
    window.setInterval(() => {
      this.now = new Date();
    }, 300);
  },
  mounted() {
    this.authenticate();
  },
  computed: {
    partyIsNear() {
      // disable this feature for now
      return false;

      const daysLastToBeConsideredNear = 14;
      return this.partyDate - this.now < 86400000 * daysLastToBeConsideredNear;
    },
    countdownLast() {
      if (this.partyIsNear) {
        return this.partyDate - this.now;
      }

      return this.ticketSaleStart - this.now;
    },
    countdownDays() {
      // 1000 msecs * 60 secs * 60 mins * 24 hours = 86400000
      return Math.floor(this.countdownLast / 86400000);
    },
    countdownHours() {
      // 1000 msecs * 60 secs * 60 mins = 3600000
      let res = Math.floor(this.countdownLast / 3600000) % 24;
      return res < 10 ? "0" + res : res;
    },
    countdownMins() {
      // 1000 msecs * 60 secs = 600000
      let res = Math.floor(this.countdownLast / 60000) % 60;
      return res < 10 ? "0" + res : res;
    },
    countdownSecs() {
      // 1000 msecs
      let res = Math.floor(this.countdownLast / 1000) % 60;
      return res < 10 ? "0" + res : res;
    },
    countdownMSecs() {
      let res = Math.floor(this.countdownLast / 10) % 100;
      return res < 10 ? "0" + res : res;
    },
    navigation() {
      if (true || this.user) {
        const isAdminRoute = this.$route.matched.some(({ name }) => {
          name === "admin";
        });

        if (isAdminRoute) {
          return ADMIN_NAVIGATION;
        }
      }

      return NAVIGATION;
    },
  },
  methods: {
    activateTwitter(e) {
      if (!this.twitterActive) {
        if (
          confirm(
            "Durch die Aktivierung des Tweet-Buttons werden Cookies von Twitter gespeichert. Forfahren?"
          )
        ) {
          window.twttr = (function (d, s, id) {
            var js,
              fjs = d.getElementsByTagName(s)[0],
              t = window.twttr || {};
            if (d.getElementById(id)) {
              return t;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function (f) {
              t._e.push(f);
            };

            return t;
          })(document, "script", "twitter-wjs");
          this.twitterActive = true;
        }
        e.stopPropagation();
        return false;
      }
    },
    authenticate() {
      const credentials = JSON.parse(localStorage.getItem("API_CREDENTIALS"));
      if (credentials) {
        axios
          .get(`${process.env.VUE_APP_API}/auth/profile`, {
            headers: {
              Authorization: `Bearer ${credentials.auth.access_token}`,
            },
            params: {
              id: credentials.info.resource_owner_id,
            },
          })
          .then((response) => {
            this.user = response.data;
          });
      }
    },
    logout() {
      const credentials = JSON.parse(localStorage.getItem("API_CREDENTIALS"));
      axios
        .post(`${process.env.VUE_APP_API}/auth/logout`, {
          token: credentials.auth.access_token,
        })
        .then(() => {
          this.user = null;
          localStorage.removeItem("API_CREDENTIALS");
          this.$router.go();
        });
    },
    setLocale(locale) {
      localStorage.setItem("LOCALE", locale);
      this.$root.$i18n.locale = locale;
    },

    toggleLocationChooser() {
      this.locationChooserActive = !this.locationChooserActive;
    },
  },
  watch: {
    $route() {
      // Whenever route changes, close the mobile nav, i.e. user clicked a link
      this.navOpen = false;
      this.authenticate();
    },
  },
};
